import presentingComplaintOptions from './presentingComplaintOptions'

// Mirrored in mobile/src/components/EPCR/panels/History/injuryComplaints.js
const INJURY_GROUP = 'Trauma & Injuries'

// Fast Track complaints are a flat list, so the injury ones are named here.
const FAST_TRACK_INJURIES = [
  'Animal or Insect Bite / Sting',
  'Blister',
  'Bruise or contusion',
  'Foreign body (skin or eye)',
  'Graze',
  'Loose or avulsed tooth',
  'Minor burn or scald',
  'Minor cut or laceration',
  'Minor head injury',
  'Minor soft tissue injury',
  'Splinter',
  'Stubbed toe or finger',
]

const NOT_INJURED = /no injury|not injured/i

const injuryLabels = new Set([
  ...(presentingComplaintOptions[INJURY_GROUP] || []).map((x) => (typeof x === 'string' ? x : x.label)),
  ...FAST_TRACK_INJURIES,
])

export const isInjuryComplaint = (label) => {
  if (!label || NOT_INJURED.test(label)) return false
  // The regex catches free-typed / tenant-configured complaints
  return injuryLabels.has(label) || /injur/i.test(label)
}

export const hasInjuryComplaint = (complaints) => (complaints || []).some(isInjuryComplaint)

// The answer is stored on incident.injuryOccurredAtEvent (the Incident tab's
// "Did it occur at the event?"), so "before this event" is the inverse.
const INVERSE = { Yes: 'No', No: 'Yes', Unknown: 'Unknown' }
export const OCCURRED_BEFORE_EVENT_OPTIONS = ['Yes', 'No', 'Unknown']
export const toOccurredBeforeEvent = (occurredAtEvent) => INVERSE[occurredAtEvent] || ''
export const toOccurredAtEvent = (occurredBeforeEvent) => INVERSE[occurredBeforeEvent]
